// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { registerBackend } from './backend-impl';
//# sourceMappingURL=backend.js.map